import styled from 'styled-components';
import 'react-datepicker/dist/react-datepicker.css';
import { font } from '../../../const/font';
import { colors } from '../../../const/color';
import {
  formControlBasic,
  formControlColorVariant,
  formControlDisabledVariant,
  formControlFocusVariant,
  formControlPlaceholder,
} from '../../../const/form-element';
import { IconStyled } from '../../icon';

export const FormDatepickerStyled = styled.div`
  .react-datepicker {
    border: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.07);
    font-family: ${font.family.primary};
    border-radius: 0;

    &-wrapper {
      display: block;
      flex: 1;
    }
    
    &__header {
      background: ${colors.white};
    }

    &-popper {
      z-index: 20;
    }
    
    &-popper[data-placement^='top'] .react-datepicker__triangle,
    &-popper[data-placement^='bottom'] .react-datepicker__triangle {
      display: none;
    }
    &__input-container {
      input {
          height: 32px;
          border-top-left-radius: 4px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          border-bottom-left-radius: 4px;
          appearance: none;
          box-shadow: none;
          font-size: ${font.size.md}px;
          padding: 7px 10px;
          
          /* Basic styles */
          ${formControlBasic}
        
          /* Color variations */
          ${formControlColorVariant()}
        
          /* Placeholder customization */
          ${formControlPlaceholder}
        
          /* Focus state */
          ${formControlFocusVariant}
        
          /* Disabled state */
          ${formControlDisabledVariant}
      }
    }
    &__navigation--years-upcoming::before {
      border-color: #000;
      border-style: solid;
      border-width: 3px 3px 0 0;
      content: "";
      display: block;
      height: 9px;
      position: absolute;
      top: 27px;
      width: 9px;
      -webkit-transform: rotate(135deg) translateX(-15px);
      -ms-transform: rotate(135deg) translateX(-15px);
      transform: rotate(-45deg) translateX(14px);
    }
    &__navigation--years-previous::before {
      border-color: #000;
      border-style: solid;
      border-width: 3px 3px 0 0;
      content: "";
      display: block;
      height: 9px;
      position: absolute;
      top: 15px;
      width: 9px;
      transform: rotate(135deg) translateX(-15px);
    }
    &__current-month {
      text-transform: capitalize;
    }

    .react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name {
      text-transform: capitalize;
    }
  }
`;

export const FormDatepickerIconCloseStyled = styled.div`
  cursor: pointer;
  background-color: ${colors.primary};
  border-radius: 100%;
  border: 0;
  outline: 0;
  padding: 0;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  height: 20px;
  width: 20px;

  > span {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;

    svg,
    svg * {
      fill: white;
    }
  }
`;
export const FormDatepickerIconStyled = styled.label`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  ${IconStyled} * {
    fill: ${colors?.white};
    stroke: ${colors?.primary};
  }
  &:hover {
    background: ${colors?.primary};
    ${IconStyled} * {
      fill: ${colors?.primary};
      stroke: ${colors.white};
    }
  }
`;
